"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _php = _interopRequireDefault(require("highlight.js/lib/languages/php"));

var _default = _php.default;
exports.default = _default;